module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-utilities-monitor"
  }, [_c('h1', [_vm._v("水电监控")]), _c('br'), _c('div', {
    staticClass: "ui statistics"
  }, [_c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.avarage.water.toFixed(2)) + " 吨")]), _c('div', {
    staticClass: "label"
  }, [_vm._v("30天人均冷水用量")])]), _c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.avarage.hot_water.toFixed(2)) + " 吨")]), _c('div', {
    staticClass: "label"
  }, [_vm._v("30天人均热水用量")])]), _c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.avarage.electricity.toFixed(2)) + " 度")]), _c('div', {
    staticClass: "label"
  }, [_vm._v("30天人均电用量")])])]), _c('br'), _c('br'), _c('table', {
    staticClass: "ui celled structured table"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.details), function(record) {
    return (record.contracts.length) ? _c('tr', {
      class: {
        disabled: record.untrusted
      }
    }, [_c('td', {
      staticClass: "center aligned"
    }, [_vm._v(_vm._s(record.no))]), _c('td', {
      staticClass: "collapsing customers"
    }, [_vm._v(_vm._s(_vm.$formatters.customers_summary(record.customers)))]), _c('td', {
      staticClass: "center aligned"
    }, [_vm._v(_vm._s(record.customers.length))]), _c('td', {
      staticClass: "center aligned"
    }, [_vm._v(_vm._s(record.contracts.length))]), _c('td', {
      staticClass: "center aligned"
    }, [_vm._v(_vm._s(record.rented_days))]), _c('td', {
      staticClass: "center aligned shadow"
    }, [_vm._v(_vm._s(record.room_utilities.water))]), _c('td', {
      staticClass: "center aligned shadow"
    }, [_vm._v(_vm._s(record.room_utilities.hot_water))]), _c('td', {
      staticClass: "center aligned shadow"
    }, [_vm._v(_vm._s(record.room_utilities.electricity))]), _c('td', {
      staticClass: "center aligned shadow"
    }, [_vm._v(_vm._s(record.room_utilities.kitchen))]), _c('td', {
      staticClass: "center aligned"
    }, [_vm._v(_vm._s(record.charges.water))]), _c('td', {
      staticClass: "center aligned"
    }, [_vm._v(_vm._s(record.charges.hot_water))]), _c('td', {
      staticClass: "center aligned"
    }, [_vm._v(_vm._s(record.charges.electricity))]), _c('td', {
      staticClass: "center aligned"
    }, [_vm._v(_vm._s(record.charges.kitchen))]), _c('td', {
      staticClass: "center aligned shadow"
    }, [(record.state.text) ? _c('div', {
      staticClass: "ui label",
      class: record.state.color
    }, [_vm._v(_vm._s(record.state.text))]) : _vm._e()]), _c('td', {
      staticClass: "center aligned",
      style: (_vm.severity(record, "water"))
    }, [_vm._v(_vm._s(record.average_usage.water.toFixed(1)))]), _c('td', {
      staticClass: "center aligned",
      style: (_vm.severity(record, "hot_water"))
    }, [_vm._v(" " + _vm._s(record.average_usage.hot_water.toFixed(1)))]), _c('td', {
      staticClass: "center aligned",
      style: (_vm.severity(record, "electricity"))
    }, [_vm._v(" " + _vm._s(record.average_usage.electricity.toFixed(1)))]), _c('td', {
      staticClass: "center aligned"
    }, [_vm._v(_vm._s(record.average_usage.kitchen.toFixed(1)))])]) : _vm._e()
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "center aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("房"), _c('br'), _vm._v("號")]), _c('th', {
    staticClass: "center aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("当前住客")]), _c('th', {
    staticClass: "center aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("住客"), _c('br'), _vm._v("人数")]), _c('th', {
    staticClass: "center aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("合同"), _c('br'), _vm._v("数量")]), _c('th', {
    staticClass: "center aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("入住"), _c('br'), _vm._v("天数")]), _c('th', {
    staticClass: "center aligned",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("入住时水电")]), _c('th', {
    staticClass: "center aligned",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("出租期间充值水电")]), _c('th', {
    staticClass: "center aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("备注")]), _c('th', {
    staticClass: "center aligned",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("平均用量 /30天/人")])]), _c('tr', [_c('th', {
    staticClass: "center aligned"
  }, [_vm._v("冷水")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("热水")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("电")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("厨房")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("冷水")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("热水")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("电")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("厨房")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("冷水")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("热水")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("电")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("厨房")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-539e64e6","hasScoped":true}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/reports/UtilitiesMonitor.vue
// module id = 557
// module chunks = 0